// @flow
import { foodModes } from '../../dataTypes/orderRequests/foodModes';


export const foodMode2translarionMap: Map<string, string> = new Map([
  [foodModes.Afternoon, 'order_requests_food_mode_afternoon'],
  [foodModes.Breakfast, 'order_requests_food_mode_breakfast'],
  [foodModes.Dinner, 'order_requests_food_mode_dinner'],
]);
